import { createContext } from "react";

/** Lets a containing action tray give every icon pill the same control height. */
export const IconButtonHeightContext = createContext<number | undefined>(undefined);
